/**
 * @file Action types.
 */

import { createActionTypes } from '../utilities';

const namespacedActionTypes = createActionTypes(`my-account`, [
	`START_CHANGE_PASSWORD_REQUEST`,
	`RECEIVE_SUCCESS_RESPONSE`,
	`RECEIVE_ERROR_RESPONSE`,
]);

const globalActionTypes = createActionTypes(undefined, [
	`RESET`,
]);

export default {
	...namespacedActionTypes,
	...globalActionTypes,
};
